import React, { useState, useEffect } from "react";
import { Trash2 } from "lucide-react";
import { Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { useMenu } from "../../context/MenuContext";
import { toast } from "react-toastify";
import { FaStar } from "react-icons/fa";
// ✅ SweetAlert2 import

// ✅ Base64 Images (for recommended items only)
const jeansImg = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD...";
const pantsImg = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IC4AA...";
const offerCard = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA...";

const API_URL = "https://code.gurusport.in/api/cart";
const COUPON_API = "https://code.gurusport.in/api/apply-coupon";

const CartPage = () => {
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [couponApplied, setCouponApplied] = useState(false);
  // const [promoCode, setPromoCode] = useState("");
  // const [promoDiscount, setPromoDiscount] = useState(0);
  // const [promoMessage, setPromoMessage] = useState("");
  const [selectedItems, setSelectedItems] = useState([]); // ✅ Bulk delete
  const {
    promoCode,
    setPromoCode,
    promoDiscount,
    setPromoDiscount,
    finalAmount,
    setFinalAmount,
    promoMessage,
    setPromoMessage,
    fetchMenuCounts = () => {},
    setCartCount = () => {},
  } = useMenu() || {};

  // calculate subtotal from cartItems
  const subtotal = cartItems.reduce(
    (acc, item) => acc + parseFloat(item.price) * item.quantity,
    0
  );

  // Whenever subtotal or promoDiscount changes, update final amount
  useEffect(() => {
    // If coupon discount is present, subtract, else final amount = subtotal
    if (promoDiscount && promoDiscount > 0) {
      setFinalAmount(subtotal - promoDiscount);
    } else {
      setFinalAmount(subtotal);
    }
  }, [subtotal, promoDiscount, setFinalAmount]);

  // ✅ Get tokens
  const getAuthData = () => {
    const authToken = localStorage.getItem("authToken");
    const guestToken = localStorage.getItem("guest_token");
    const userId = localStorage.getItem("authUserId");
    return { authToken, guestToken, userId };
  };

  // ✅ Fetch Cart
  const fetchCart = async () => {
    try {
      setLoading(true);
      const { authToken, guestToken, userId } = getAuthData();
      let res;

      if (authToken && userId) {
        // Logged in
        res = await axios.get(API_URL, {
          headers: { Authorization: `Bearer ${authToken}` },
          params: { user_id: userId },
        });
      } else {
        // Guest
        res = await axios.get(`${API_URL}?guest_token=${guestToken}`);
      }

      if (res.data && res.data.data.length > 0) {
        const mergedItems = res.data.data.flatMap((cart) => cart.items || []);
        const withQty = mergedItems.map((item) => ({
          ...item,
          quantity: item.quantity || 1,
        }));
        setCartItems(withQty);
      } else {
        setCartItems([]);
      }
    } catch (err) {
      console.error("❌ Error fetching cart:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCart();
  }, []);

  // ✅ Update Quantity
  const updateQuantity = async (itemId, newQty) => {
    try {
      const { authToken, guestToken, userId } = getAuthData();

      if (userId) {
        // Logged in
        await axios.put(
          `${API_URL}/${itemId}`,
          { product_id: itemId, quantity: newQty, user_id: userId },
          { headers: { Authorization: `Bearer ${authToken}` } }
        );
      } else {
        // Guest
        await axios.put(
          `${API_URL}/${itemId}?guest_token=${guestToken}`,
          { product_id: itemId, quantity: newQty },
          { headers: { Authorization: `Bearer ${guestToken}` } }
        );
      }

      // setCartItems((prev) =>
      //   prev.map((item) =>
      //     item.id === itemId ? { ...item, quantity: newQty } : item
      //   )
      // );

      setCartItems((prev) => {
        const updatedItems = prev.map((item) => {
          if (item.id === itemId) {
            console.log(`Updating item with ID: ${item.id}`); // Log the item being updated
            return { ...item, quantity: newQty };
          }
          return item;
        });

        console.log("Updated Cart Items:", updatedItems); // Log the updated cart items after mapping
        return updatedItems;
      });
    } catch (err) {
      console.error("❌ Error updating quantity:", err);
    }
  };

  // ✅ Remove Item
  const removeFromCart = async (itemId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to remove this item from your cart?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, remove it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const { authToken, guestToken, userId } = getAuthData();
          let response;
          if (userId) {
            response = await axios.delete(`${API_URL}/${itemId}`, {
              headers: { Authorization: `Bearer ${authToken}` },
              data: { user_id: userId },
            });
          } else {
            response = await axios.delete(
              `${API_URL}/${itemId}?guest_token=${guestToken}`,
              {
                headers: { Authorization: `Bearer ${guestToken}` },
              }
            );
          }

          const res = response;

          if (res.data.success) {
            setCartItems((prev) => prev.filter((item) => item.id !== itemId));

            if (authToken) {
              fetchMenuCounts(userId);
            } else {
              setCartCount(res.data.cart);
            }
            toast.success("Product removed from cart");
          } else {
            toast.error(res.data.message || "Failed to remove product");
          }

          // setCartItems((prev) => prev.filter((item) => item.id !== itemId));
          // Swal.fire("Deleted!", "Your item has been removed.", "success");
        } catch (err) {
          console.error("❌ Error removing item:", err);
          Swal.fire("Error!", "Failed to remove item.", "error");
        }
      }
    });
  };

  // ✅ Clear Cart
  const clearCart = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "This will clear your entire cart!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, clear it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const { authToken, guestToken, userId } = getAuthData();
          console.log("guestToken", guestToken);
          let response;
          if (userId) {
            response = await axios.delete(API_URL, {
              data: { clear_all: true, user_id: userId },
              headers: { Authorization: `Bearer ${authToken}` },
            });
          } else {
            response = await axios.delete(
              `${API_URL}?guest_token=${guestToken}`,
              {
                data: { clear_all: true },
                headers: { Authorization: `Bearer ${guestToken}` },
              }
            );
          }

          const res = response;

          if (res.data.success) {
            if (authToken) {
              fetchMenuCounts(userId);
            } else {
              setCartCount(res.data.cart || 0);
            }
            toast.success("Product removed from cart");
          } else {
            toast.error(res.data.message || "Failed to remove product");
          }

          setCartItems([]);
          Swal.fire("Cleared!", "Your cart has been emptied.", "success");
        } catch (err) {
          console.error("❌ Error clearing cart:", err);
          Swal.fire("Error!", "Failed to clear cart.", "error");
        }
      }
    });
  };

  // ✅ Bulk Delete
  const handleBulkDelete = () => {
    selectedItems.forEach((id) => removeFromCart(id));
    setSelectedItems([]);
  };

  const toggleSelection = (id) => {
    setSelectedItems((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  // Promo code handler
  const handlePromoApply = async () => {
    try {
      const authToken = localStorage.getItem("authToken");
      const userId = localStorage.getItem("authUserId");

      const res = await axios.post(
        COUPON_API,
        {
          user_id: userId,
          coupon_code: promoCode,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (res.data.success) {
        const { discount, final_amount } = res.data;
        // set discount and message
        setPromoDiscount(discount || 0);
        setFinalAmount(final_amount || subtotal - (discount || 0));
        setPromoMessage("✅ Coupon Applied Successfully!");
      } else {
        setPromoDiscount(0);
        setFinalAmount(subtotal);
        setPromoMessage("❌ Invalid or expired coupon.");
      }
    } catch (err) {
      console.error("❌ Error applying coupon:", err);
      setPromoDiscount(0);
      setFinalAmount(subtotal);
      setPromoMessage("❌ Failed to apply coupon. Try again later.");
    }
  };

  if (loading) {
    return <div className="text-center py-10">Loading cart...</div>;
  }

  if (!cartItems || cartItems.length === 0) {
    return (
      <div className="text-center py-10">
        <h2 className="text-xl font-bold">Your cart is empty 🛒</h2>
      </div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
      {/* Header */}
      <div className="flex justify-between items-center flex-wrap gap-4">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold mb-2">Your Cart</h1>
          <p className="mb-4 text-gray-600 text-sm">
            You have{" "}
            <span className="text-red-600 font-bold">{cartItems.length}</span>{" "}
            product(s) in your cart.
          </p>
        </div>
        {selectedItems.length > 0 && (
          <button
            onClick={handleBulkDelete}
            className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 text-sm sm:text-base"
          >
            Delete Selected ({selectedItems.length})
          </button>
        )}
      </div>

      {/* Main Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Left: Cart Items */}
        <div className="md:col-span-2 space-y-4">
          {cartItems.map((item) => (
            <div
              key={item.id}
              className="grid grid-cols-[30px_80px_1fr_auto] sm:grid-cols-[40px_100px_1fr_auto] gap-4 items-start p-4 bg-white shadow rounded-lg"
            >
              <input
                type="checkbox"
                checked={selectedItems.includes(item.id)}
                onChange={() => toggleSelection(item.id)}
                className="mt-2"
              />
              <img
                src={item.product?.default_image || "#"}
                alt={item.product?.name}
                className="w-[70px] h-[70px] sm:w-[90px] sm:h-[90px] object-cover rounded"
              />

              <div>
                <h2 className="text-sm sm:text-base font-semibold">
                  {item.product?.name}
                </h2>
                <div className="text-yellow-500 text-xs sm:text-sm">
                  <p className="text-gray-500 mt-1 flex items-center gap-1">
                    {Array.from({ length: 5 }).map((_, starIdx) => (
                      <FaStar
                        key={starIdx}
                        className={`${
                          starIdx < Math.round(item?.star || 0)
                            ? "text-yellow-400"
                            : "text-gray-300"
                        }`}
                      />
                    ))}
                  </p>
                </div>

                {/* Quantity Controls */}
                <div className="mt-2 text-xs sm:text-sm flex items-center bg-gray-200 px-2 py-1 w-max rounded">
                  <strong>Qty:</strong>
                  <button
                    className="px-2 border rounded"
                    onClick={() =>
                      updateQuantity(item.id, Math.max(1, item.quantity - 1))
                    }
                  >
                    -
                  </button>
                  <span className="px-2">{item.quantity}</span>
                  <button
                    className="px-2 border rounded"
                    onClick={() => updateQuantity(item.id, item.quantity + 1)}
                  >
                    +
                  </button>
                </div>

                <div className="mt-2 text-xs sm:text-sm">
                  <span className="font-bold">
                    ₹{(parseFloat(item.price) * item.quantity).toFixed(2)}
                  </span>
                </div>
              </div>

              <button
                onClick={() => removeFromCart(item.id)}
                className="text-red-500 hover:text-red-700 self-start"
              >
                <Trash2 size={18} />
              </button>
            </div>
          ))}
        </div>

        {/* Right: Summary */}
        <div className="w-full max-w-md p-5 bg-white rounded-lg shadow-md mx-auto md:mx-0">
          <h2 className="text-xl sm:text-2xl font-bold mb-4">Order Summary</h2>

          <div className="flex justify-between mb-2 text-gray-600 text-sm sm:text-base">
            <span>Subtotal</span>
            <span>₹{subtotal.toFixed(2)}</span>
          </div>

          {promoDiscount > 0 && (
            <div className="flex justify-between mb-2 text-green-700 text-sm sm:text-base">
              <span>Promo Code</span>
              <span>-₹{promoDiscount.toFixed(2)}</span>
            </div>
          )}

          <hr className="mb-4 border-gray-300" />

          <div className="flex justify-between font-bold text-base sm:text-lg mb-4">
            <span>Total</span>
            <span>₹{finalAmount.toFixed(2)}</span>
          </div>

          <div className="flex items-center mb-4 gap-2">
            <input
              type="text"
              placeholder="Add promo code"
              value={promoCode}
              onChange={(e) => setPromoCode(e.target.value)}
              className="flex-grow bg-gray-100 border px-3 py-2 rounded-full outline-none text-sm"
            />
            <button
              onClick={handlePromoApply}
              className="bg-red-600 text-white px-4 py-2 hover:bg-red-700 font-medium rounded-full text-sm"
            >
              Apply
            </button>
          </div>

          {promoMessage && (
            <p className="text-xs sm:text-sm mb-2 text-gray-700">
              {promoMessage}
            </p>
          )}

          <Link to="/payment">
            <button className="w-full bg-red-600 text-white py-3 rounded hover:bg-red-700 font-bold mt-4 text-sm sm:text-base">
              🛍️ CHECKOUT
            </button>
          </Link>

          <button
            onClick={clearCart}
            className="w-full mt-4 bg-gray-200 text-gray-700 py-2 rounded hover:bg-gray-300 text-sm"
          >
            Clear Cart
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
